import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiUrl } from '@brand-lolly/app/_services/base-api-urls';
import { catchError, Observable, of } from 'rxjs';
import { CreditBalance } from '@brand-lolly/app/billing/types/credit-balance.types';

/**
 * Reads the calling brand's Influencer API credit balance. The public API
 * debits this balance per call; the billing page renders it as a widget.
 * Degrades to "no subscription" so a failed/absent read never breaks the page.
 */
@Injectable({ providedIn: 'root' })
export class GetCreditBalanceService {
	private readonly url = `${BaseApiUrl.SocialMessengerPython}billing/credits`;

	constructor(private http: HttpClient) {}

	get(): Observable<CreditBalance> {
		return this.http.get<CreditBalance>(this.url).pipe(
			catchError(() =>
				of<CreditBalance>({
					has_subscription: false,
					balance_credits: null
				})
			)
		);
	}
}
